import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ReleaseNotesService } from '@app/shared/services/api/release-notes.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ReleaseNoteDialogComponent } from '@app/release-note-admin/dialog/release-note-dialog/release-note-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { DescriptionSnackbarComponent } from '@app/shared/components/description-snackbar/description-snackbar.component';
import { TranslateService } from '@ngx-translate/core';
import { isDate } from 'lodash';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';

@Component({
  selector: 'app-release-note-form',
  templateUrl: './release-note-form.component.html',
  styleUrls: ['./release-note-form.component.scss'],
})
export class ReleaseNoteFormComponent implements OnInit {
  @Output() refreshList = new EventEmitter<any>();

  constructor(
    public matDialog: MatDialog,
    private releaseNotesService: ReleaseNotesService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private overlayLoaderService: OverlayLoaderService
  ) {}

  releaseNoteForm = new FormGroup({
    releaseDate: new FormControl('', [Validators.required]),
    notes: new FormControl('', [Validators.required]),
  });

  isDraft = true;
  updateSuccessText = '';
  saveErrorText = '';

  ngOnInit() {
    this.translateService.get('module.userProfile.generalInformation.updateSuccessText').subscribe((text) => (this.updateSuccessText = text));
    this.translateService.get('module.userProfile.saveErrorText').subscribe((val) => (this.saveErrorText = val));

    this.releaseNotesService.activeReleaseNote$.subscribe((data) => {
      this.isDraft = true;

      if (data === null) {
        this.releaseNoteForm.reset();
      } else {
        this.isDraft = data.publishDate === null;
        this.releaseNoteForm.patchValue(data);
      }
    });

    this.releaseNoteForm.valueChanges.subscribe((_) => {});
  }

  preview() {
    if (this.releaseNoteForm.valid) {
      const notesValue = this.releaseNoteForm.controls.notes.value;
      const data = [
        {
          releaseDate: this.releaseNoteForm.controls.releaseDate.value,
          notes: notesValue,
          notesList: notesValue ? notesValue.split('\n') : [],
        },
      ];

      this.matDialog.open(ReleaseNoteDialogComponent, {
        data: {
          releaseItems: data,
          title: 'Neuerungen seit der letzten Anmeldung',
        },
        panelClass: '-md',
      });
    }
  }

  draft() {
    if (this.releaseNoteForm.valid) {
      this.saveReleaseNote(false);
    }
  }

  publish() {
    if (this.releaseNoteForm.valid) {
      const matRef = this.matDialog.open(NotificationDialogComponent, {
        data: {
          descriptionText: 'Sind Sie sicher, dass Sie die Neuerungen veröffentlichen möchten?',
          title: 'Neuerungen verwalten',
          confirmText: 'Neuerungen veröffentlichen',
          declineText: 'Abbrechen',
        },
        panelClass: ['-md'],
      });

      matRef.afterClosed().subscribe((res) => {
        if (res) {
          this.saveReleaseNote(true);
        }
      });
    }
  }

  saveReleaseNote(isPublished: boolean) {
    this.overlayLoaderService.isLoading = true;
    let releaseNote = this.releaseNotesService.getActiveReleaseNote;

    const releaseDateValue = this.releaseNoteForm.controls.releaseDate.value;
    const date = isDate(releaseDateValue) ? releaseDateValue : releaseDateValue ? new Date(releaseDateValue) : new Date();

    const releaseDate = new Date();
    releaseDate.setFullYear(date.getFullYear());
    releaseDate.setMonth(date.getMonth());
    releaseDate.setDate(date.getDate());

    if (releaseNote && releaseNote.id !== null) {
      releaseNote.isPublished = isPublished;
      releaseNote.releaseDate = releaseDate;
      releaseNote.notes = this.releaseNoteForm.controls.notes.value || '';

      this.releaseNotesService.put(releaseNote.id, releaseNote).subscribe({
        next: () => {
          this.successCallback();
        },
        error: () => {
          this.errorCallback();
        },
      });
    } else {
      releaseNote = {
        id: null,
        releaseDate: releaseDate,
        isPublished: isPublished,
        notes: this.releaseNoteForm.controls.notes.value || '',
      };

      this.releaseNotesService.post(releaseNote).subscribe({
        next: () => {
          this.successCallback();
        },
        error: () => {
          this.errorCallback();
        },
      });
    }
  }

  successCallback() {
    this.refreshList.emit();
    this.overlayLoaderService.isLoading = false;
    this.snackBar.openFromComponent(DescriptionSnackbarComponent, {
      data: {
        text: this.updateSuccessText,
      },
      duration: 3000,
      horizontalPosition: 'right',
    });

    this.releaseNoteForm.controls.releaseDate.setValue(null);
    this.releaseNoteForm.controls.notes.setValue(null);
    this.releaseNotesService.activeReleaseNote = null;
  }

  errorCallback() {
    this.overlayLoaderService.isLoading = false;
    this.snackBar.openFromComponent(DescriptionSnackbarComponent, {
      data: {
        text: this.saveErrorText,
      },
      duration: 3000,
      horizontalPosition: 'right',
    });
  }
}
